// ==============================
// Free Jersey Guardrail (ROBUST)
// - Random codes OK
// - Targets jersey by PRODUCT ID (covers all size variants)
// - Enforces cap ONLY when jersey is FREE (or discounted to $0)
// ==============================
// <-- replace with the numeric product id (no quotes), e.g. 12345678901234
const FREE_JERSEY_PRODUCT_IDS = [
  10068026917159, 10083551379751
];

const GUARDRAIL_MESSAGE = "Limit 1 free jersey per order.";

async function fetchCartJSON() {
  const res = await fetch("/cart.json", { credentials: "same-origin" });
  if (!res.ok) return null;
  return await res.json();
}

function isTargetJerseyItem(item) {
  // cart.json items usually include product_id
  return FREE_JERSEY_PRODUCT_IDS.includes(item.product_id);
}

function isLineFree(item) {
  // Prefer final_line_price (line total) when present
  if (typeof item.final_line_price === "number") return item.final_line_price === 0;

  // Fallback: sometimes themes expose final_price per-unit and quantity separately
  if (typeof item.final_price === "number" && typeof item.quantity === "number") {
    return (item.final_price * item.quantity) === 0;
  }

  return false;
}

function showGuardrailMessage(msg) {
  try {
    let el = document.getElementById("free-jersey-guardrail-msg");
    if (!el) {
      el = document.createElement("div");
      el.id = "free-jersey-guardrail-msg";
      el.style.padding = "12px";
      el.style.margin = "12px 0";
      el.style.border = "1px solid rgba(0,0,0,0.25)";
      el.style.borderRadius = "10px";
      el.style.fontSize = "14px";
      el.style.background = "rgba(0,0,0,0.03)";
      el.style.lineHeight = "1.3";

      const mount =
        document.querySelector('form[action^="/cart"]') ||
        document.querySelector("main") ||
        document.body;

      mount.prepend(el);
    }
    el.textContent = msg;
  } catch (e) {}
}

async function enforceOneFreeJerseyMax() {
  const cart = await fetchCartJSON();
  if (!cart || !Array.isArray(cart.items)) return;

  const jerseyLines = cart.items.filter(isTargetJerseyItem);
  if (!jerseyLines.length) return;

  // SAFETY: only enforce if at least one jersey line is actually FREE
  const hasFreeJersey = jerseyLines.some(isLineFree);
  if (!hasFreeJersey) return;

  // Cap TOTAL jersey quantity across ALL jersey lines/variants to 1
  let remaining = 1;
  const updates = {};
  let didUpdate = false;

  for (const line of jerseyLines) {
    if (remaining <= 0) {
      updates[line.key] = 0; // remove extras
      didUpdate = true;
      continue;
    }

    if (line.quantity > remaining) {
      updates[line.key] = remaining; // reduce to 1
      didUpdate = true;
      remaining = 0;
    } else {
      remaining -= line.quantity;
    }
  }

  if (!didUpdate) return;

  const updateRes = await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ updates })
  });

  if (updateRes.ok) {
    showGuardrailMessage(GUARDRAIL_MESSAGE);
    location.reload();
  }
}

// Run on cart page load
document.addEventListener("DOMContentLoaded", () => {
  if (location.pathname.startsWith("/cart")) {
    enforceOneFreeJerseyMax().catch(() => {});
  }
});

// Best-effort for AJAX carts / cart drawers:
let _guardrailTimer = null;
function scheduleGuardrail() {
  clearTimeout(_guardrailTimer);
  _guardrailTimer = setTimeout(() => {
    enforceOneFreeJerseyMax().catch(() => {});
  }, 700);
}
document.addEventListener("cart:refresh", scheduleGuardrail);
document.addEventListener("cart:updated", scheduleGuardrail);
document.addEventListener("cart:change", scheduleGuardrail);

// Fallback observer (helps with drawers)
const _obs = new MutationObserver(() => scheduleGuardrail());
_obs.observe(document.documentElement, { childList: true, subtree: true });
